export default __webpack_public_path__ + "static/media/background-login.479d30d6.svg";